import React, { FC, useEffect, useRef } from 'react';
import { useAuthContext } from '../AuthProvider';
import { Loading } from '../../_common';
import { Routes } from '../../../utils';
import './Callback.scss';

/** True if the URL looks like an OIDC redirect (implicit: hash has state; code: query has state). */
function hasOidcResponse(): boolean {
    const hash = window.location.hash || '';
    const query = window.location.search || '';
    return /[?&]state=/.test(query) || /[#&]state=/.test(hash);
}

const Callback: FC = (): React.JSX.Element => {
    const { userManager } = useAuthContext();
    const handled = useRef(false);

    useEffect(() => {
        if (handled.current) return;
        if (!hasOidcResponse()) {
            window.location.href = window.location.origin;
            return;
        }
        handled.current = true;
        userManager
            .signinRedirectCallback()
            .then(user => {
                if (user) {
                    window.location.href = `${window.location.origin}${Routes.HOME.route}`;
                } else {
                    window.location.href = window.location.origin;
                }
            })
            .catch(() => {
                window.location.href = window.location.origin;
            });
    }, [userManager]);

    return (
        <span className="Callback-Loading">
            <Loading />
        </span>
    );
};

export default Callback;
